export function onDOMContentLoaded(callback: () => Promise<void>) {
	if (!window.__EARLY_SPA_ENTRY_POINT_EXECUTION__) {
		void callback();
		return;
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', callback);
	} else {
		void callback();
	}
}
